import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {brandT} from '@/lib/types/brand.types';

interface BRAND_STATE {
  brands: brandT[];
  isLoading: boolean;
  error: string | null;
}

const BRAND_INITIAL: BRAND_STATE = {
  brands: [],
  isLoading: false,
  error: null,
};

const brandSlice = createSlice({
  name: 'brand',
  initialState: {
    ...BRAND_INITIAL,
  },
  reducers: {
    BRAND_UPDATE: (state, action: PayloadAction<{data?: BRAND_STATE; prop?: string; value?: string | Date}>) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? {[action.payload.prop]: action.payload.value} : null),
      });
    },
  },
});

const {BRAND_UPDATE} = brandSlice.actions;

export {brandSlice, BRAND_INITIAL, BRAND_UPDATE};
